// extracted by mini-css-extract-plugin
export default {"linksDiagram":"styles_linksDiagram__cjqQ5"};